export default {

  /**
   * @param array array
   * @return number|NaN
   */
  max (array) {
    return Math.max.apply(null, array)
  },

  /**
   * @param array array
   * @return number|NaN
   */
  min (array) {
    return Math.min.apply(null, array)
  },

  /**
   * Returns the difference between the largest and smallest value in the array
   *
   * @param array array
   * @return number|NaN
   */
  range (array) {
    return this.max(array) - this.min(array)
  },

  /**
   * @param array array
   * @return number|NaN
   */
  midrange (array) {
    return this.range(array) / 2
  },

  /**
   * @param array array
   * @return number|NaN
   */
  sum (array) {
    var num = 0
    for (var i = 0, l = array.length; i < l; i++) num += array[i]
    return num
  },

  /**
   * @param array array
   * @return number|NaN
   */
  mean (array) {
    return this.sum(array) / array.length
  },

  /**
   * @param array array
   * @return number|NaN
   */
  median (array) {
    array.sort(function (a, b) {
      return a - b
    })
    var mid = array.length / 2
    return mid % 1 ? array[mid - 0.5] : (array[mid - 1] + array[mid]) / 2
  },

  /**
   * @param array array
   * @return number|NaN
   */
  modes (array) {
    if (!array.length) return []
    var modeMap = {}
    var maxCount = 0
    var modes = []

    array.forEach(function (val) {
      if (!modeMap[val]) modeMap[val] = 1
      else modeMap[val]++

      if (modeMap[val] > maxCount) {
        modes = [val]
        maxCount = modeMap[val]
      } else if (modeMap[val] === maxCount) {
        modes.push(val)
        maxCount = modeMap[val]
      }
    })
    return modes
  },

  /**
   * @param array array
   * @return number|NaN
   */
  variance (array) {
    var mean = this.mean(array)
    return this.mean(array.map(function (num) {
      return Math.pow(num - mean, 2)
    }))
  },

  /**
   * @param array array
   * @return number|NaN
   */
  standardDeviation (array) {
    return Math.sqrt(this.variance(array))
  },

  /**
   * @param array array
   * @return number|NaN
   */
  meanAbsoluteDeviation (array) {
    var mean = this.mean(array)
    return this.mean(array.map(function (num) {
      return Math.abs(num - mean)
    }))
  },

  /**
   * @param array array
   * @return array
   */
  zScores (array) {
    var mean = this.mean(array)
    var standardDeviation = this.standardDeviation(array)
    return array.map(function (num) {
      return (num - mean) / standardDeviation
    })
  }

}
